import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { User } from "../../_models/user";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';

@Component({
  selector: 'app-admin-manage-gati',
  templateUrl: './admin-manage-gati.component.html',
  styleUrls: ['./admin-manage-gati.component.scss'],
})
export class AdminManageGatiComponent implements OnInit {
  connectionName: string;
  carrierNameError: string;
  customerCode: string;
  customerCodeError: string;
  gatiList: any = {};
  carrierId: any;

  constructor(private api: ApiIntegration, private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {

    this.carrierId = this.route.snapshot.paramMap.get('id');
    if (this.carrierId) {
      this.api.adminGetCarrierInfoById(this.carrierId, this.user.organizationId).subscribe((data: any) => {
        this.gatiList = data;
      }, err => {
        this.alertService.error('Error', err);
      });
    }
  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.gatiList.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  customerCodeBlur() {
    this.customerCodeError = "";
    if (!this.gatiList.customerCode) {
      this.customerCodeError = 'Please enter customer code';
    }
  }


  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.customerCodeError = "";

    if (!this.gatiList.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.gatiList.customerCode) {
      this.customerCodeError = 'Please enter customer code';
    }
    if (this.carrierNameError != "" || this.customerCodeError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateCarrierCredentials', {
      "connectionName": this.gatiList.connectionName,
      "carrierCode": this.gatiList.carrierCode,
      "organizationId": this.gatiList.organizationId,
      "customerCode": this.gatiList.customerCode,
      "carrierId": this.gatiList.carrierId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Gati', 'Create Successfully');
          this.router.navigate(['/admin/adminCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }

}
